<template>
  <div>
    <b-tabs>
      <b-tab title="Detalhamento" style="overflow: auto; height: 60vh">
        <b-table stacked :items="form" :fields="colunas" head-variant="dark"></b-table>
      </b-tab>
      <b-tab title="Projetos P&D (Regra antiga)" style="overflow: auto; height: 60vh">
        <b-table :items="rn219" head-variant="dark" :fields="colunasProjetos">
          <template #cell(titulo)="dados">
            <div>
              {{ dados.value }}
              <i
                class="fas fa-level-up-alt"
                style="transform: rotate(90deg); font-size: 18px; color: #999"
                v-if="!dados.value"
              ></i>
            </div>
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Projetos P&D (Regra nova)" style="overflow: auto; height: 60vh">
        <b-table :items="rn316" head-variant="dark" :fields="colunasProjetos">
          <template #cell(titulo)="dados">
            <div>
              {{ dados.value }}
              <i
                class="fas fa-level-up-alt"
                style="transform: rotate(90deg); font-size: 18px; color: #999"
                v-if="!dados.value"
              ></i>
            </div>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import helpers from "@/common/utils/helpers";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
export default {
  props: {
    form: {
      type: Array,
      default: () => [],
    },
    empresaId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    colunas: [
      { key: "ano", label: "Ano" },
      { key: "mes", label: "Mês" },
      {
        key: "rol",
        label: "Valor mensal da ROL da Empresa no Mês de Referência",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "fndct",
        label: "Valor recolhido ao FNDCT pela Empresa no Mês de Referência",
        formatter: (a, b, c) => helpers.formatarValor(c.rol * 0.4),
      },
      {
        key: "mme",
        label: "Valor recolhido ao MME pela Empresa no Mês de Referência",
        formatter: (a, b, c) => helpers.formatarValor(c.rol * 0.2),
      },
      {
        key: "pd",
        label: "Valor à investir em P&D ANEEL pela Empresa no Mês de Referência",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "cde",
        label: "Valor recolhido ao CDE P&D pela Empresa no Mês de Referência",
        formatter: (a, b, c) => {
          let mes = helpers.retornarMeses().find((mes) => mes.enum == c.mes);
          return (
            (c.ano >= 2021 && c.ano <= 2025) ||
            (mes.value >= 9 && c.ano >= 2020 && c.ano <= 2025)
              ? 0.7
              : 1
          )
            ? helpers.formatarValor(c.rol * 0.4 * 0.3)
            : "-";
        },
      },

      {
        key: "saldoAcumulado.saldoCCSegundoMesAnterior",
        label:
          "Saldo acumulado na conta contábil de P&D da empresa no segundo mês anterior ao mês de referência",
        formatter: (value) => helpers.formatarValor(value || 0),
      },
      {
        key: "saldoAcumulado.saldoCCMesAnterior",
        label:
          "Saldo acumulado na conta contábil de P&D da empresa no mês anterior ao mês de referência",
        formatter: (value) => helpers.formatarValor(value || 0),
      },
      {
        key: "saldoAcumulado.saldoCCServicosSegundoMesAnterior",
        label:
          "Saldo acumulado na conta contábil de serviços em curso da empresa no segundo mês anterior ao mês de referência",
        formatter: (value) => helpers.formatarValor(value || 0),
      },
      {
        key: "saldoAcumulado.saldoCCServicosMesAnterior ",
        label:
          "Saldo acumulado na conta contábil de serviços em curso da empresa no mês anterior ao mês de referência",
        formatter: (value) => helpers.formatarValor(value || 0),
      },
      {
        key: "saldoAcumulado.saldoCCServicosMesReferencia",
        label:
          "Saldo acumulado na conta contábil de serviços em curso da empresa no mês de referência",
        formatter: (value) => helpers.formatarValor(value || 0),
      },

      {
        key: "somatoriaValoresDebitados",
        label: "Valor debitado na conta no mês de referência",
        formatter: (value) => helpers.formatarValor(value),
      },

      {
        key: "lancamentosRegraAntiga",
        label:
          "Soma dos lançamentos financeiros efetuados pela empresa em Projetos de P&D no mês de referência, sob regulamentação da Res.Normativa 219/2006 (regra antiga) e anteriores",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "lancamentosRegraNova",
        label:
          "Soma dos lançamentos financeiros efetuados pela empresa em Projetos de P&D e de Gestão no mês de referência, sob regulamentação da Res.Normativa 316/2008 (regra nova)",
        formatter: (value) => helpers.formatarValor(value),
      },

      {
        key: "taxaSelic",
        label: "Taxa SELIC (%) no mês de referência",
        formatter: (value) => helpers.formatarValor(value),
      },

      {
        key: "remuneracaoSELIC",
        label:
          "Valor da remuneração SELIC do mês de referência, da diferença entre o saldo acumulado na CC de P&D, no segundo mês anterior ao mês de referência, e o saldo acumulado na CC serviços em curso, no segundo mês anterior ao mês de referência",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "saldo",
        label:
          "Saldo da CC de P&D da empresa, no mês de referência, obtida após a soma do saldo da CC de P&D do mês anterior ao mês de referência, ao valor agregado pela SELIC, no mês de referência, e ao valor a investir em P&D, no mês de referência",
        formatter: (value) => helpers.formatarValor(value),
      },
    ],
    colunasProjetos: [
      { key: "titulo", label: "Titulo do projeto" },
      { key: "codigo", label: "Codigo do projeto" },
      { key: "custoProprio", label: "Rubrica" },
      {
        key: "valorCustoProprio",
        label: "Custos próprios",
        formatter: (v) => {
          if (v) return helpers.formatarValor(v);
        },
      },
      { key: "executora", label: "Executoras" },
      {
        key: "valorDesembolso",
        label: "Valores notas fiscais",
        formatter: (v) => {
          if (v) return helpers.formatarValor(v);
        },
      },
    ],
    rn219: [],
    rn316: [],
  }),
  mounted() {
    this.buscarProjetosRN219();
    this.buscarProjetos();
  },
  methods: {
    criarRubrica: function (dados, rubrica, projeto) {
      if (projeto[rubrica] == 0) return;
      dados.push({
        titulo: dados.find((el) => el.titulo == projeto.titulo) ? "" : projeto.titulo,
        codigo: dados.find((el) => el.titulo == projeto.titulo) ? "" : projeto.codigo,
        custoProprio: rubrica.toUpperCase(),
        valorCustoProprio: projeto[rubrica],
        executora: "",
        valorDesembolso: 0,
      });
    },
    criarDesembolso: function (dados, projeto) {
      dados.push(
        ...projeto.desembolso.map((desembolso) => {
          return {
            titulo: dados.find((el) => el.titulo == projeto.titulo) ? "" : projeto.titulo,
            codigo: dados.find((el) => el.titulo == projeto.titulo) ? "" : projeto.codigo,
            custoProprio: "",
            valorCustoProprio: 0,
            executora: desembolso.empresa,
            valorDesembolso: desembolso.valor,
          };
        })
      );
    },
    formatarProjetos: function (projetos) {
      let dados = [];
      projetos.forEach((projeto) => {
        this.criarRubrica(dados, "rh", projeto);
        this.criarRubrica(dados, "st", projeto);
        this.criarRubrica(dados, "mc", projeto);
        this.criarRubrica(dados, "mpe", projeto);
        this.criarRubrica(dados, "vd", projeto);
        this.criarRubrica(dados, "ou", projeto);
        this.criarRubrica(dados, "ct", projeto);
        this.criarRubrica(dados, "ac", projeto);
        this.criarDesembolso(dados, projeto);
      });

      let totalCusto = dados.reduce((total, el) => total + el.valorCustoProprio, 0);
      let totalDesembolso = dados.reduce((total, el) => total + el.valorDesembolso, 0);

      dados.push({
        titulo: " ",
        codigo: "",
        custoProprio: "",
        valorCustoProprio: totalCusto,
        executora: "",
        valorDesembolso: totalDesembolso,
        _rowVariant: "warning",
      });
      dados.push({
        titulo: "Total",
        codigo: "",
        custoProprio: "",
        valorCustoProprio: 0,
        executora: "",
        valorDesembolso: totalCusto + totalDesembolso,
        _rowVariant: "warning",
      });

      return dados;
    },
    buscarProjetosRN219: function () {
      let filtro = {
        mes: this.form[0].mes,
        ano: this.form[0].ano,
        empresaId: this.empresaId,
      };
      MovimentacaoFinanceiraService.buscarProjetosRN219(filtro).then((res) => {
        this.rn219 = this.formatarProjetos(res.data.data);
      });
    },
    buscarProjetos: function () {
      let filtro = {
        mes: this.form[0].mes,
        ano: this.form[0].ano,
        empresaId: this.empresaId,
      };
      MovimentacaoFinanceiraService.buscarProjetos(filtro).then((res) => {
        this.rn316 = this.formatarProjetos(res.data.data);
      });
    },
  },
};
</script>
<style>
.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
  text-align: justify;
  width: 80% !important;
}
.table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
  width: 20% !important;
}
</style>
